import { j as u } from "./jsx-runtime-3tyXYecC.mjs";
import { m as x } from "./tss-DN0acMKN.mjs";
import { M as g, d as f } from "./constants-CnFYFetN.mjs";
import { T as d } from "./Typography-DfkimCSn.mjs";
const h = (e) => {
  switch (e) {
    case "large":
      return "22px";
    case "medium":
      return "20px";
    case "small":
      return "17px";
    case "teenie":
    default:
      return "15px";
  }
}, S = (e) => {
  switch (e) {
    case "large":
      return "1px";
    case "medium":
      return "0.8px";
    case "small":
      return "0.6px";
    case "teenie":
    default:
      return "0.4px";
  }
}, y = x()(
  ({ mode: e, palette: a, typography: r }, { color: n, gray: o, size: t, letterSpacing: i, lineHeight: c, margin: m }) => {
    var s;
    return {
      root: {
        color: e === g.Dye ? f.main : n || a.gray[o],
        fontSize: (s = r[t]) == null ? void 0 : s.fontSize,
        fontWeight: r.fontWeightSemibold,
        letterSpacing: i || S(t),
        lineHeight: c || h(t),
        margin: m,
        textTransform: "uppercase"
      }
    };
  }
), T = ({
  children: e,
  className: a,
  color: r,
  gray: n = 800,
  margin: o,
  level: t = "h2",
  letterSpacing: i,
  lineHeight: c,
  size: m = "teenie",
  ...s
}) => {
  const { classes: p, cx: l } = y({ color: r, gray: n, letterSpacing: i, lineHeight: c, margin: o, size: m });
  return /* @__PURE__ */ u.jsx(d, { className: l(p.root, a), component: t, "data-fabric-component": "AllCapsHeading", ...s, children: e });
};
export {
  T as A
};
//# sourceMappingURL=all-caps-heading-D9yBHIpC.mjs.map
